<template>
  <page @click="() => batchSetData = ''">
    <module :title="id ? '编辑APP图标/背景模板' : '添加APP图标/背景模板'">
        <c-form ref="form">
            <c-form-item type="hidden" name="id"></c-form-item>
			<c-form-item type="input" label="模板名称" name="template_name" required></c-form-item>
			<c-form-item type="datetime" label="生效时间" start-name="effect_start_time" end-name="effect_end_time" required></c-form-item>
			<c-form-item type="radio" v-model="enableStateDate" label="启禁用" name="enable_state" :options="enableState" required></c-form-item>
			<c-form-item type="input" label="跳转路径" name="link_params"></c-form-item>
			<c-form-item type="radio" v-model="pushTypeDate" label="推送依据" name="push_type" :options="pushType" required></c-form-item>
			<c-form-item type="image" v-show="pushTypeDate == 1" label="广告图" name="advert_img"
				   file-word="消息、采购单、分类、确认订单等模块背景; 图片尺寸: 750X248px。jpg，png格式" required>
			</c-form-item>
			<c-form-item type="image" v-show="pushTypeDate == 2" label="长屏广告图" name="long_advert_img"
				   file-word="广告图尺寸1080x2560。图片支持jpg、jpeg、BMP、GIF或pgn格式，大小不超过5m。注意由于不同设备屏幕比例不同。" required>
			</c-form-item>
			<c-form-item type="image" v-show="pushTypeDate == 2" label="短屏广告图" name="short_advert_img"
				   file-word="广告图尺寸1080x1920。图片支持jpg、jpeg、BMP、GIF或pgn格式，大小不超过5m。注意由于不同设备屏幕比例不同。" required>
			</c-form-item>
        </c-form>

      <template slot="button">
        <c-button size="m" @click="submitForm()">提交保存</c-button>
      </template>
    </module>
  </page>
</template>

<script>
export default {
  name: 'b_app_start_adv_edit',
  data() {
    return {
            enableState: [
                {name: '启用',value: 1},
                {name: '禁用',value: 2}
            ],
            enableStateDate:1,
            pushType: [
                {name: '全部机型',value: 1},
                {name: '按屏幕比例',value: 2}
            ],
            pushTypeDate:1
    }
  },
  props: {
    id: String
  },
  computed: {

  },

  watch: {
    id() {
        this.getDetail();
    },
  },

  mounted() {
        if (this.id) {
            this.getDetail();
        }
  },
  methods: {
    /**加载详情**/
    getDetail() {
      this.request({
        url:'/start/adv/temp/detail',
        data: {
          id: this.id
        },
        loading: true,
        success: data => {
          this.$refs.form.set(data);
        }
      });
    },
    /*****提交数据******/
    submit() {
               var submit_obj = this.$refs.form.serialize();
               this.request({
                       url:'/start/adv/temp/edit',
                       data:submit_obj,
                       success: data => {
                            this.$message({
                                text: '保存成功'
                            });
                            //刷新列表
                            this.$bus.$emit('app_style_list.update', {})
                       }
               });
    },
    submitForm() {
        this.$refs.form.submit({
            url:'/start/adv/temp/edit',
            rule: {
                template_name: '请填写模板名称',
                effect_start_time: '请选择生效开始时间',
                effect_end_time: '请选择生效截止时间'
            },
            success: (data, res) => {
                this.$message({
                    text: '保存成功'
                });
                this.$bus.$emit('start_adv_temp_list.update', {})
            }
        });
    }
  }
}
</script>